import { Bot, Send, ShieldCheck } from 'lucide-react'
import { useState, type FormEvent } from 'react'

import { Button } from '../../components/ui/Button'
import { PageHeader } from '../../components/ui/PageHeader'
import { useAppState } from '../../state/AppState'

export function TutorPage() {
  const [draft, setDraft] = useState('')
  const { messages, addStudentMessage } = useAppState()

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    addStudentMessage(draft)
    setDraft('')
  }

  return (
    <div className="content-page tutor-page">
      <PageHeader
        title="AI导师"
        description="先诊断卡点，再逐级提示；完整答案不是默认选项。"
      />

      <div className="info-banner" role="status">
        <ShieldCheck size={19} strokeWidth={1.7} aria-hidden="true" />
        <div>
          <strong>当前为本地交互演示</strong>
          <span>聊天记录只保存在当前浏览器，尚未连接外部 AI 模型。</span>
        </div>
      </div>

      <section className="chat-surface" aria-label="AI 辅导会话">
        <div className="chat-surface__messages" aria-live="polite">
          {messages.map((message) => (
            <article
              key={message.id}
              className={`chat-message chat-message--${message.role}`}
            >
              <span className="chat-message__avatar" aria-hidden="true">
                {message.role === 'tutor' ? <Bot size={18} /> : 'S'}
              </span>
              <div>
                <strong>{message.role === 'tutor' ? 'AI导师' : '我'}</strong>
                <p>{message.content}</p>
              </div>
            </article>
          ))}
        </div>

        <form className="chat-composer" onSubmit={handleSubmit}>
          <label htmlFor="tutor-message">写下题目或你已经想到的步骤</label>
          <div className="chat-composer__row">
            <textarea
              id="tutor-message"
              value={draft}
              rows={3}
              placeholder="例如：我觉得应该先求定义域，但不知道下一步……"
              onChange={(event) => setDraft(event.target.value)}
            />
            <Button
              type="submit"
              aria-label="发送消息"
              disabled={!draft.trim()}
              leadingIcon={<Send size={17} />}
            >
              发送
            </Button>
          </div>
        </form>
      </section>
    </div>
  )
}
